import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { get, pick, map, set, find, concat, includes, isNil, omit } from 'lodash';
import moment from 'moment';
import cx from 'classnames';
import ReactTooltip from 'react-tooltip';
import { concat as concatStrings } from '../../lib/strings';
import DeleteIcon from '../svgs/DeleteIcon';
import IconButton from 'material-ui/IconButton';
import RouteTransitionBlocker from '../../react/r_ApplicantDashboard/f_RouteTransitionBlocker';

import DropDownMenu from './c_DropDownMenu';
import CheckList from './c_CheckList';
import FlagIcon from '../svgs/FlagIcon';
import ChevronIcon from '../svgs/ChevronIcon';
import CardFilter from './CardFilter';

import * as companyApi from '../../redux/actionCreators/async/companies';
import * as contactApi from '../../redux/actionCreators/async/contacts';
import * as contactStore from '../../redux/actionCreators/sync/contacts';
import * as companyStore from '../../redux/actionCreators/sync/companies';
import * as jobRequestApi from '../../redux/actionCreators/async/jobrequests';
import * as ui from '../../redux/actionCreators/sync/ui';

import {lookup, getLookupValue} from '../../redux/helpers/staticData';
import prettyPhone from '../../lib/prettyPhone';
import Button from './Button';

import Pager from 'rc-pager';
import PreviousIcon from '../../common/svgs/PreviousIcon';
import NextIcon from '../../common/svgs/NextIcon';

import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn
} from 'material-ui/Table';

const dateOptions = [
  {id: -1, name: 'All'},
  {id: 'past due', name: 'Past Due'},
  {id: 'today', name: 'Today'},
  {id: 'tomorrow', name: 'Tomorrow'},
  {id: 'this week', name: 'This Week'},
  {id: 'next week', name: 'Next Week'},
  {id: 'this month', name: 'This Month'},
  {id: 'future', name: 'Future'}
];

const contactDateOptions = [
  {id: -1, name: 'All'},
  {id: 'today', name: 'Today'},
  {id: 'yesterday', name: 'Yesterday'},
  {id: 'past week', name: 'Past Week'},
  {id: 'past month', name: 'Past Month'},
  {id: 'past year', name: 'Past Year'}
];

const jobOptions = [
  {id: 'jobsSubmitted', name: 'Submitted', sortBy: 'submitted'},
  {id: 'jobsApproved', name: 'Approved', sortBy: 'approved'},
  {id: 'jobsPlaced', name: 'Placed', sortBy: 'placed'},
  {id: 'jobs', name: 'Total', sortBy: 'total'},
];

@connect((store, props) => {
  const staticData = store.staticData;

  return {
    staticData,
    contactLabels: get(store.labels, 'ContactTypes', {}),
    currentUser  : store.user
  };
})
export default class ContactTable extends Component {

  static propTypes = {
		dispatch : PropTypes.func.isRequired,
    contacts: PropTypes.array,
    className: PropTypes.string,
		staticData: PropTypes.object,
    contactLink: PropTypes.bool,
    companyLink: PropTypes.bool,
    showHeader: PropTypes.bool,
    columns: PropTypes.array,
    useContactTypeDropdown: PropTypes.bool,
    useCheckBoxes: PropTypes.bool,
    onRowSelection: PropTypes.func,
    onEdit: PropTypes.func,
    total: PropTypes.number,
    onPageChange: PropTypes.func,
    updateContactsFilter: PropTypes.func,
    shouldDisplayEditAction: PropTypes.func,
    minWidth: PropTypes.string,
    sortBy: PropTypes.object,
    filters: PropTypes.object,
    onSort: PropTypes.func,
    handlePageSkip: PropTypes.func,
    currentPage: PropTypes.number,
    pageSize: PropTypes.number,
    currentUser: PropTypes.object,
    location: PropTypes.string
	}

  constructor(props, context) {
    super(props, context);

    this.state = {
      clientAdvisers: this.props.staticData.clientAdvisers,
      showHeader: this.props.showHeader !== undefined ? this.props.showHeader : true,
      showFilters: get(this.props, 'showFilters', true),
      showDeleteModal: false,
      deleteContact: {},
      isFlipped: true,
      columns: this.props.columns !== undefined ? this.props.columns : [
        'Name',
        'Phone',
        'Title',
        'Type',
        'Status',
        'Email'
      ],
      sortBy: props.sortBy || {
        field: 'contactedDate',
        order: 'desc'
      },
      hasPagination: (props.location && props.location.includes('/admin/contacts')) || includes(props, '/admin/contacts')
    };
    this.hasNoJobsFilter = ::this.hasNoJobsFilter;
    this.onChangeFilter = ::this.onChangeFilter;
    this.showDeleteModal = ::this.showDeleteModal;
    this.closeDeleteModal = ::this.closeDeleteModal;
    this.handleDeleteContact = ::this.handleDeleteContact;
  }

  componentWillReceiveProps(nextProps) {
    ReactTooltip.rebuild();
  }

  handleFilterDefaultValues(filterName) {
    const defaultVal = (filterName === 'tags') ? [] : -1;
    return get(this.props.filters, filterName, defaultVal);
  }

  hasNoJobsFilter() {
    const filters = this.props.filters;
    const jobFilters = ['jobsSubmitted', 'jobsApproved', 'jobsPlaced', 'jobs'];
    return jobFilters.every((job) => isNil(filters[job]) || filters[job] === 0);
  }

  getJobFilters() {
    const jobFilters = pick(this.props.filters, ['jobsSubmitted', 'jobsApproved', 'jobsPlaced', 'jobs']);
    return Object.keys(jobFilters);
  }
  flipColumn() {
    let sortBy = 'total';
    const jobFilters = this.getJobFilters();
    const totalJobFilters = jobFilters.length;

    // We sort by total unless there are only 1 filter.
    if(totalJobFilters === 1) {
      sortBy = find(jobOptions, {id: jobFilters[0]}).sortBy;
    }

    this.setState({
      isFlipped: !this.state.isFlipped,
      sortBy: {field: sortBy, order: this.state.isFlipped ? 'desc' : 'asc'}
    }, () => {
      const fields = { order: get(this.state, 'sortBy.order'), by: get(this.state, 'sortBy.field')};
      this.props.onSort(fields);
    });
  }

  onCardFilter(event, key, text, value) {
    let data = 0;

    if (key.indexOf(value) >= 0) data = 1;
    this.props.updateContactsFilter(event, data, value);
  }

  onChangeFilter(filterSection, filterName) {
    return (event, key) => {
      if (this.props.updateContactsFilter) this.props.updateContactsFilter(event, key, filterName);
    };
  }

  handleContactClick(row, route = '') {
    return () => {
      if (this.props.contactLink) {
        this.props.dispatch(ui.showSpinner());
        this.props.dispatch(push(`/admin/contacts/${row.profile.id}/${route}`));
      }
    };
  }

  handleCompanyClick(row, route = 'details') {
    return () => {
      if (this.props.companyLink) {
        this.props.dispatch(ui.showSpinner());
        this.props.dispatch(push(`/admin/companies/${row.company.id}/${route}`));
      }
    };
  }

  onChangeContactType(row) {
    return (event, types) => {
      const contact = {
        user: pick(row.user, ['id']),
        company: pick(row.company, ['id']),
        profile: {
          id: row.profile.id,
          types
        }
      };
      this.props.dispatch(contactApi.updateContact(contact, (err, result) => {
        if (err || !result) {
          return console.error(err || 'Update failed.');
        }

        this.props.dispatch(contactStore.updateContact(result));
      }));
    };
  }

  getFollowUpDate(contact) {
    const followUpTask = _(contact.profile.tasks)
      .filter(task => task.taskFollowUpDate)
      .sortBy(task => new Date(task.taskFollowUpDate))
      .head();

    return followUpTask ? moment(followUpTask.taskFollowUpDate).format('L') : '';
  }

  generateMenuItemsAddNoTag(staticData, type, hideAny) {
    const NO_TAG_MAGIC_NUMBER = 9999;
    const menuItems = this.generateMenuItems(staticData, type, hideAny);
    return concat(menuItems, {value: NO_TAG_MAGIC_NUMBER, primaryText: 'No Tags'});
  }
  
  generateMenuItems(staticData, type, hideAny) {
    const object = staticData[type];

    const menuItems = map(object, function(item) {
      return {
        value: item.id || item.value,
        primaryText: (item.name || item.primaryText)
      };
    });

    if (hideAny) {
      return menuItems;
    }

    return concat({value: -1, primaryText: 'All'}, menuItems);
  }

  generateContactTypeMenuItems() {
    const menuItems = map(this.props.staticData.contactTypes, (type) => {
      return {
        value: type.id,
        primaryText: get(this.props.contactLabels, type.name)
      };
    });

    return menuItems;
  }

  employeesToMenuItems(employees = []) {
    const menuItems = map(employees, (employee) => {
      return {
        primaryText: `${employee.firstName} ${employee.lastName}`,
        value: employee.employeeId,
      };
    });

    return concat([{value: -1, primaryText: 'All'}, {value: null, primaryText: 'Unassigned'}], menuItems);
  }

  showDeleteModal(deleteContact) {
    return () => {
      this.setState({showDeleteModal: true, deleteContact});
    };
  }

  closeDeleteModal() {
    this.setState({showDeleteModal: false});
  }

  handleDeleteContact = () => {

    const { dispatch, contacts } = this.props;
    const { deleteContact } = this.state;
    const { user, company, profile } = deleteContact;
    const filteredContacts = contacts.filter((c) => c.user.id !== user.id);
    const fullname = concatStrings([user.firstName, user.lastName], ' ');

    dispatch(companyApi.deleteCompanyContact(company.id, profile.id, (err) => {

      this.setState({showDeleteModal: false});

      if (err) {
        return dispatch(ui.warningToast(get(err, '[0].errorMessage', 'Unable to delete contact.')));
      }

      dispatch(companyStore.updateCompanyContacts(filteredContacts));
      dispatch(ui.showSnackBar(`Contact ${fullname} deleted.`));
    }));

  }

  // column render functions
  renderName(header, row, index) {
    if (header) {
      return <TableHeaderColumn key={'contact-name'} className='contact-name' style={{ width: '150px'}}>Contact</TableHeaderColumn>
    }

    return <TableRowColumn data-id={`Contact${index}`} className='contact-name' style={{ width: '150px'}}>
      <div className={this.props.contactLink && 'hover-link'} onClick={this.handleContactClick(row, 'details')}>{row.user.firstName} {row.user.lastName}</div>
    </TableRowColumn>
  }

  renderCardName(header, row, index) {
    if (header) {
      return <TableHeaderColumn key={'contact-card-name'} className='contact-name' style={{ width: '250px'}}>Contact</TableHeaderColumn>
    }

    return <TableRowColumn data-id={`Contact${index}`} className='contact-name' style={{ width: '250px'}}>
      <div className='contact-name-card hover-link'>
        <div className='expand-icon' onClick={this.handleContactClick(row)}></div>
        <div className='name' onClick={this.handleContactClick(row, 'details')}>{row.user.firstName} {row.user.lastName}</div>
      </div>
    </TableRowColumn>
  }

  renderCompany(header, row, index) {
    if (header) {
      return <TableHeaderColumn key={'headercol-company'} className='contact-company' style={{ width: '150px'}}>Company</TableHeaderColumn>
    }

    return <TableRowColumn data-id={`Company${index}`} style={{ width: '150px'}} className='contact-company-name' >
      <div className='contact-name-card hover-link' onClick={this.handleCompanyClick(row)}>{row.company.name}</div>
    </TableRowColumn>
  }

  renderPhone(header, row, index) {
    if (header) {
      return <TableHeaderColumn key={'headercol-phone'} className='contact-phone' style={{width: '150px'}}>Phone #</TableHeaderColumn>
    }

    return <TableRowColumn data-id={`Phone${index}`} className='contact-phone' style={{width: '150px'}}>
      {!!row.user.phoneNumber1 && prettyPhone(row.user.phoneNumber1)}
    </TableRowColumn>
  }

  renderContactDate(header, row, index) {
    if (header) {
      return <TableHeaderColumn key={'headercol-contact-date'} className='contact-date' style={{width: '150px'}}>Contacted</TableHeaderColumn>
    }

    return <TableRowColumn data-id={`Contact Date ${index}`} className='contact-date' style={{width: '150px'}}>
      {row.profile.dateCreated ? moment(row.profile.dateCreated).format('L') : ''}
    </TableRowColumn>
  }

  renderFollowUpDate(header, row, index) {
    if (header) {
      return <TableHeaderColumn key={'headercol-followupdate'} className='contact-followup-date'>Follow Up</TableHeaderColumn>
    }

    return <TableRowColumn data-id={`FollowUp Date${index}`} className='contact-followup-date'>
      {this.getFollowUpDate(row)}
    </TableRowColumn>
  }

  renderTitle(header, row, index) {
    if (header) {
      return <TableHeaderColumn key={'headercol-title'} className='contact-title' style={{ width: '125px'}}>Title</TableHeaderColumn>
    }

    return <TableRowColumn data-id={`Title${index}`} className='contact-title' style={{ width: '125px'}}>
      {row.profile.title}
    </TableRowColumn>
  }

  renderJobCounts(header, row, index) {
    if (header) {
      return (<TableHeaderColumn key={'headercol-jobs'} className='contact-jobs'>#JRs
        <div className={cx('chevron', {flipped: this.state.isFlipped})} onClick={::this.flipColumn}>
          <ChevronIcon/>
        </div>
        <CardFilter
          onChange={::this.onCardFilter}
          menuItems={jobOptions}
        />
      </TableHeaderColumn>);
    }

    const showAll = this.hasNoJobsFilter();
    const filters = this.props.filters;
    return (<TableRowColumn data-id={`Jobs ${index}`} className='contact-jobs'>
      <div className='job-counts'>
        {(showAll || !!filters.jobsSubmitted) &&
          <div data-tip='Job Requests Submitted' className={cx('submitted-circle', {'empty-circle': row.profile.jobsSubmitted == 0})}>
            {row.profile.jobsSubmitted > 99 ? '99+' : row.profile.jobsSubmitted}
          </div>
        }
        {(showAll || !!filters.jobsApproved) &&
          <div data-tip='Job Requests Approved' className={cx('approved-circle', {'empty-circle': row.profile.jobsApproved == 0})}>
            {row.profile.jobsApproved > 99 ? '99+' : row.profile.jobsApproved}
          </div>
        }
        {(showAll || !!filters.jobsPlaced) &&
          <div data-tip='Job Requests Placed' className={cx('placed-circle', {'empty-circle': row.profile.jobsPlaced == 0})}>
            {row.profile.jobsPlaced > 99 ? '99+' : row.profile.jobsPlaced}
          </div>}
        {(showAll || !!filters.jobs) &&
          <div data-tip='Total Job Requests' className={cx('total-circle', {'empty-circle': row.profile.jobs == 0})}>
            {row.profile.jobs > 99 ? '99+' : row.profile.jobs}
          </div>
        }
      </div>
    </TableRowColumn>);
  }

  renderType(header, row, index) {
    if (header) {
      return <TableHeaderColumn key={`headercol-type-${index}`} className='contact-type'  style={{width: '128px'}}>Type</TableHeaderColumn>;
    }
    if(this.props.useContactTypeDropdown) {
      return <TableRowColumn data-id={`Type${index}`} className='contact-type'  style={{width: '128px'}}>
        <CheckList
        data-id="contact-type-dropdown"
        onChange={this.onChangeContactType(row)}
        defaultValue={row.profile.types}
        className='dropdown-filter'
        menuItems={this.generateContactTypeMenuItems()}
        containerStyle={{width: '100%'}}
         />
      </TableRowColumn>;
    } else {
      return <TableRowColumn data-id={`Type${index}`} className='contact-type'  style={{width: '128px'}}>
          { map(row.profile.types, (id) => lookup(this.props.staticData, 'contactTypes', {id})).join(', ')}
      </TableRowColumn>;
    }

  }

  renderStatus(header, row, index) {
    if (header) {
      return <TableHeaderColumn key={`headercol-status-${index}`} className='contact-status' style={{width: '150px'}}>Status</TableHeaderColumn>
    }

    return <TableRowColumn data-id={`Status${index}`} className='contact-status' style={{width: '150px'}}>
      {row.color !== undefined
        &&
        <div className='status-circle' data-id='Status Icon' style={{backgroundColor: row.color, borderColor: row.color}}></div>
      }
      {lookup(this.props.staticData, 'companyStatus', {id: row.company.companyStatus})}
    </TableRowColumn>
  }

  renderTags(header, row, index) {
    if (header) {
      return <TableHeaderColumn key={`headercol-status-${index}`} className='contact-status-tags' style={{height: 'auto', width: 'auto', paddingRight: '0'}}/>
    }

    return <TableRowColumn data-id={`Tags ${index}`} className='contact-status-tags' style={{height: 'auto', width: 'auto', paddingRight: '0'}}>
      <span className='contact-tags contact-tags-inline'>{map(row.profile.tags, (tag) =>
        <div className='contact-tag' data-id={`Contact tag ${tag}`}><FlagIcon /> {lookup(this.props.staticData, 'contactTags', {id: tag})}</div>
      )}</span>
    </TableRowColumn>
  }

  renderEmail(header, row, index) {
    if (header) {
      return <TableHeaderColumn key={`headercol-email-${index}`} className='contact-email' style={{ width: '250px'}}>Email</TableHeaderColumn>
    }

    return <TableRowColumn data-id={`Email${index}`} className='contact-email' style={{ width: '250px'}}>
      <a href={`mailto:${row.user.email}`} target="_blank">{row.user.email}</a>
    </TableRowColumn>
  }

  renderDelete(header, row, index) {
    if (header) {
      return <TableHeaderColumn className='delete-contact'></TableHeaderColumn>;
    }

    const deleteContact = omit(row, ['color']);
    const disabled = this.props.contacts.length < 2;
    return (
      <TableRowColumn data-id={`Deletes${index}`} className='delete-contact' style={{overflow: 'visible'}}>
        <IconButton
          tooltip='Delete'
          tooltipPosition={'bottom-center'}
          onClick={this.showDeleteModal(deleteContact)} >
          <DeleteIcon className={cx({disabled})} />
        </IconButton>
      </TableRowColumn>
    );
  }

  renderClientAdviser(header, row, index) {
    if (header) {
      return <TableHeaderColumn className='contact-adviser'>Client Adviser</TableHeaderColumn>
    }

    const adviser = find(this.state.clientAdvisers, {id: row.profile.clientAdvisorId});
    const adviserName = adviser ? `${adviser.firstName} ${adviser.lastName}` : '';

    return <TableRowColumn data-id={`Adviser${index}`} className='contact-adviser'>
      {adviserName}
    </TableRowColumn>
  }

  renderEditAction = (header, row, index)  => {
    if (header) {
      return (<TableHeaderColumn className='edit-action'/>);
    }

    const onEdit = (e) => {
        e.stopPropagation();
        this.props.onEdit(row);
    };

    if (this.props.shouldDisplayEditAction) {
      return (<TableRowColumn data-id={`Edit Action${index}`} className='edit-action' >
      {this.props.shouldDisplayEditAction(row) && <Button className='edit-button' onClick={onEdit} label='EDIT' />}
      </TableRowColumn>);
    }

    return (<TableRowColumn data-id={`Edit Action${index}`} className='edit-action' >
      <Button className='edit-button' onClick={onEdit} label='EDIT' />
    </TableRowColumn>);

  }

  handleSkip(page) {
    this.props.handlePageSkip(page);
  }


  render() {

    const {
      contacts,
      pageSize,
      currentPage,
      total,
    } = this.props;

    let currentCount = pageSize * (currentPage + 1);
    currentCount = (currentCount < total) ? currentCount : total;

      return (
        <div className={`contact-table info-table ${get(this.props, 'className', '')}`}>
          {
            this.state.showDeleteModal
            &&
            <RouteTransitionBlocker
              transitionText={'Are you sure you want to delete this contact?'}
              secondaryButtonLabel={'Delete'}
              primaryButtonLabel={'Cancel'}
              cancelAction={this.closeDeleteModal}
              primaryAction={this.closeDeleteModal}
              secondaryAction={() => this.handleDeleteContact()}
            />
          }
          {this.state.showFilters
            &&
            <div className='contact-filters'>
                <DropDownMenu
                  onChange={ this.onChangeFilter('company', 'statuses') }
                  data-id="status-dropdown"
                  floatingLabelText="Status"
                  defaultValue={this.handleFilterDefaultValues('statuses')}
                  className='dropdown-filter status-dropdown'
                  menuItems={ this.generateMenuItems(this.props.staticData, 'companyStatus') }
                />
                <CheckList
                  onChange={ this.onChangeFilter('profile', 'tags', 'tagFilters') }
                  data-id="tag-dropdown"
                  defaultValue={this.handleFilterDefaultValues('tags')}
                  popoverStyle={{width: '300px'}}
                  autoWidth={true}
                  floatingLabelText="Tag"
                  className='dropdown-filter tag-dropdown'
                  menuItems={ this.generateMenuItemsAddNoTag(this.props.staticData, 'contactTags', true) }
                />
                <DropDownMenu
                  onChange={ this.onChangeFilter('date', 'followUpDate', 'dateFilters') }
                  data-id="followup-dropdown"
                  defaultValue={this.handleFilterDefaultValues('followUpDate')}
                  floatingLabelText="Follow Up Date"
                  className='dropdown-filter'
                  menuItems={dateOptions}
                />
                <DropDownMenu
                  onChange={ this.onChangeFilter('date', 'contactedDate', 'dateFilters') }
                  data-id="contacted-dropdown"
                  defaultValue={this.handleFilterDefaultValues('contactedDate')}
                  floatingLabelText="Contacted Date"
                  className='dropdown-filter'
                  menuItems={contactDateOptions}
                />
                <DropDownMenu
                  onChange={ this.onChangeFilter('user', 'timezone') }
                  data-id="timezone-dropdown"
                  floatingLabelText="Time Zone"
                  defaultValue={this.handleFilterDefaultValues('timezone')}
                  className='dropdown-filter'
                  menuItems={ this.generateMenuItems(this.props.staticData, 'timezoneList') }
                />
                <DropDownMenu
                  onChange={ this.onChangeFilter('profile', 'clientAdvisorId') }
                  data-id="client-advisor-dropdown"
                  floatingLabelText="Account Adviser"
                  defaultValue={this.handleFilterDefaultValues('clientAdvisorId')}
                  className='dropdown-filter'
                  menuItems={this.employeesToMenuItems(this.state.clientAdvisers)}
                />
            </div>
          }
          { this.state.hasPagination &&
            <div className='pager-wrapper'>
              <div className='pager-info'>Showing <span className='count'>{currentCount}</span> of <span className='count'>{total}</span></div>
                <Pager
                  total={Math.ceil(total / pageSize)}
                  current={currentPage}
                  onSkipTo={::this.handleSkip}
                  previousLabel={<div className='prev'><PreviousIcon/> PREV</div>}
                  nextLabel={<div className='next'>NEXT <NextIcon/></div>}
                />
            </div>
          }
          <Table onRowSelection={this.props.onRowSelection}
            className="contact-main-table"
            selectable={!!this.props.useCheckBoxes}
            multiSelectable={!!this.props.useCheckBoxes}
            fixedHeader
            style={{minWidth: this.props.minWidth || '1150px'}}
            headerStyle={{minWidth: this.props.minWidth || '1150px'}}
            bodyStyle={{minWidth: this.props.minWidth || '1150px', height: this.props.height || 'calc(100vh - 229px)'}}
            >
            <TableHeader
              displaySelectAll={false}
              adjustForCheckbox={!!this.props.useCheckBoxes}
              >
              <TableRow>
                {map(this.state.columns, (column) => {
                  return this[`render${column}`](true);
                })}
              </TableRow>
            </TableHeader>
            <TableBody deselectOnClickaway={false} displayRowCheckbox={!!this.props.useCheckBoxes}>
              {map(contacts, (row, index) => {
                const status = getLookupValue(this.props.staticData, 'companyStatus', {id: row.company.companyStatus});
                row.color = status.color;
                return <TableRow selected={row.selected} className={row.disabled ? 'disabled' : 'enabled'} key={`${row.profile.id}`} data-id={`Contact ${row.user.email}`}>
                    {map(this.state.columns, (column) => {
                      return this['render'+column](false, row, index);
                    })}
                  </TableRow>
                })
              }
            </TableBody>
          </Table>
          <ReactTooltip />
        </div>
    );

  }
}



// WEBPACK FOOTER //
// ./shared/common/components/ContactTable.js